import React from "react";

const parsePaymentDetails = (value) => {
  if (!value) return null;

  try {
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
};

const PaymentDetailsPreview = ({ eventDetails }) => {
  if (
    Number(eventDetails?.accept_online_payments) !== 1 ||
    !eventDetails?.online_payment_details
  ) {
    return null;
  }

  const parsedDetails = parsePaymentDetails(eventDetails.online_payment_details);
  const accountDetails = parsedDetails?.account_details;
  const upiId = parsedDetails?.upi_id;

  if (!parsedDetails) {
    return (
      <div className="rounded-2xl border border-teal-100 bg-teal-50/40 p-4">
        <p className="text-xs font-black uppercase tracking-widest text-teal-700">
          Online Payment Details
        </p>
        <p className="mt-2 whitespace-pre-wrap text-sm leading-6 text-slate-700">
          {eventDetails.online_payment_details}
        </p>
      </div>
    );
  }

  return (
    <div className="rounded-2xl border border-teal-100 bg-teal-50/40 p-4">
      <p className="text-xs font-black uppercase tracking-widest text-teal-700">
        Online Payment Details
      </p>

      {accountDetails && (
        <div className="mt-3 rounded-xl bg-white/80 p-3">
          <p className="text-xs font-black uppercase tracking-widest text-slate-500">
            Account Details
          </p>
          <p className="mt-2 text-sm text-slate-700">
            Holder: {accountDetails.holder_name}
          </p>
          <p className="text-sm text-slate-700">
            Account Number: {accountDetails.account_number}
          </p>
          <p className="text-sm text-slate-700">
            IFSC Code: {accountDetails.ifsc_code}
          </p>
        </div>
      )}

      {upiId && (
        <div className="mt-3 rounded-xl bg-white/80 p-3">
          <p className="text-xs font-black uppercase tracking-widest text-slate-500">
            UPI Details
          </p>
          <p className="mt-2 text-sm text-slate-700">UPI ID: {upiId}</p>
        </div>
      )}
    </div>
  );
};

export default PaymentDetailsPreview;
